import { SelectSize } from "./Select.types";

export const SELECT_SIZE_CLASSES: Record<SelectSize, string> = {
  sm: "min-h-8 px-3 py-1.5 text-xs",
  md: "min-h-10 px-3 py-2 text-sm",
  lg: "min-h-12 px-3.5 py-2.5 text-sm",
};

export const SELECT_MENU_OFFSET = 6;
export const SELECT_DEFAULT_MENU_HEIGHT = 300;
export const SELECT_DEFAULT_ITEM_HEIGHT = 40;
export const SELECT_DEFAULT_OVERSCAN = 6;
export const SELECT_LOAD_MORE_THRESHOLD = 72;

export const SELECT_THEME = {
  primary: "#6B4EFF",
  primaryButton: "#7C66F0",
  text: "#1F2433",
  mutedText: "#6B7185",
  softText: "#9097A8",
  border: "#DCE2EA",
  menuBorder: "#E5E7EB",
  divider: "#EEF0F3",
  rowHover: "#F5F6F8",
  selectedBg: "#F4F2FF",
} as const;
